import { render, staticRenderFns } from "./AddStudentDialog.vue?vue&type=template&id=ee18129a"
import script from "./AddStudentDialog.vue?vue&type=script&lang=js"
export * from "./AddStudentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports